/* eslint-disable no-nested-ternary */
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { UserProfileModel } from 'mvppoker-portal-common/api'
import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { updateService } from '../../../logic/UpdateService'
import { useNavigate } from '../../../Pages/navigation'
import { useActiveUser } from '../../../state/hooks/ActiveUserHooks'
import { useAvailableRoomsLookup } from '../../../state/hooks/roomsHooks'
import ChoiceModal from '../ChoiceModal/ChoiceModal'
import { createMVPModal } from '../Modal'
import { FriendsModalView } from './FriendsModalView'
import { makeActiveGame } from '../../../state/reducers/activeGame'
import UserProfileModal from '../PlayerModal/UserProfileModal'
import { useOtherProfilesLookup, useUnreadChats } from '../../../state/hooks/ProfileDataHooks'
import { friendsService } from '../../../logic/FriendsService'
import FriendsChatModal from './Chat/FriendsChatModal'
import FriendsTransferFundsModal from './TransferFunds/FriendsTransferFundsModal'

const REFRESH_RATE = 10_000

class FriendsModal
{
	Show(showFollowToGame: boolean, showGameInvite: boolean, showChat: boolean, showTransferFunds: boolean) 
	{
		NiceModal.show(createMVPModal('friends-modal', () =>
		{
			const modal = useModal()
			const dispatch = useDispatch()
			const user = useActiveUser()
			const goToGame = useNavigate('game')
			const otherProfilesLookup = useOtherProfilesLookup()
			const rooms = useAvailableRoomsLookup()
			const { unreadChats } = useUnreadChats()

			const [isRefreshing, setRefreshing] = useState(false)

			const friends = useMemo(() => {
				const allFriends = user?.user.friends.friends.map(f => otherProfilesLookup[f]).filter(f => f) ?? []
				return allFriends.sort((a, b) => {
					if (a.info.isOnline){
						if (b.info.isOnline){
							return a.info.name.localeCompare(b.info.name)
						}
						return -1
					}
					if (b.info.isOnline){
						return 1
					}
					return a.info.name.localeCompare(b.info.name)
				})
			}, [user, otherProfilesLookup])

			const clickRefresh = () => {
				setRefreshing(true)
		
				updateService.refreshOtherProfiles(() => {
					setRefreshing(false)
				})
			}

			useEffect(() => {
				clickRefresh()
				const id = setInterval(clickRefresh, REFRESH_RATE)
		
				return () => {
					clearInterval(id)
				}
			}, [])

			const clickFriend = (friend: UserProfileModel) => {
				UserProfileModal.Show(friend)
			}
			const clickFollowToGame = (friend: UserProfileModel) => {
				const game = rooms[friend.info.currentRoom!]

				modal.hide()
				ChoiceModal.Show({
					title: 'FOLLOW FRIEND TO GAME',
					text: `Do you want to go to the game (${game.config.roomName}) that ${friend.info.name} is in?`,
					confirmTitle: 'YES',
					cancelTitle: 'NO',
					clickChoice: () => {
						const userId = user!.user.id
						dispatch(makeActiveGame({ ...game, userId }))
						goToGame({ replace: true })
					},
				})
			}
			const clickTransferFunds = (friend: UserProfileModel) => {	
				FriendsTransferFundsModal.Show(friend)
			}
			const clickGameInvite = (friend: UserProfileModel) => {
				friendsService.sendFriendsGameInvite(friend.userId)
				toast.success('FRIEND INVITED TO GAME!')
			}
			const clickChat = (friend: UserProfileModel) => {
				modal.hide()
				FriendsChatModal.Show(friend)
			}

			return <FriendsModalView 
				friends={friends}
				rooms={rooms}
				unreadChats={unreadChats}
	
				clickRefresh={clickRefresh}
				isRefreshing={isRefreshing}
				friendsListItemActions={{
					clickFriend,
					showFollowToGame,
					clickFollowToGame,
					showGameInvite,
					clickGameInvite,
					showChat,
					clickChat,
					showTransferFunds,
					clickTransferFunds
				}}
			/>
		}))
	}
}

const modal = new FriendsModal()
export default modal
